// Copyright 2005-2011 David Caldwell <david@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              king=piles.king, base64=piles.base64,
                              up=piles.up, down=piles.down;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var prnt = require('./print'), sprintf=prnt.sprintf;
var lib = require('./lib'), map=lib.map;

solitaire.pyramid = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = this.options.decks;
        this.stock = new this.stock_pile("stock", this);
        this.waste = new this.waste_pile("waste", this);
        this.discard = new this.discard_pile("discard", this);
        this.tableau = [];
        var thash = {};
        for (var r=7-1; r>=0; r--)
            for (var i=0; i<=r; i++) {
                var p = new this.tableau_pile("tableau"+r+i, this);
                p.zoffset = r;
                thash["" + r + i] = p;
                p.covered_by = [ thash[sprintf("%d%d",(r+1),i)], thash[sprintf("%d%d",r+1,i+1)] ];
                this.tableau.push(p);
            }
    }
    valid_options = { decks: option_def("number", 1, "Number of decks to use") };

    static discardable_pile = class extends pile { // Adds a couple utility functions that the other piles can use for pyramid rules.
        accept_adds_to_13(card) { return this.pile.length > 0 && this.top().rank + card.rank == 13; }

        split_to_discard(start, n, from) {
            return [{from:from, to:this,              fstart:start,              n:n, tanimate:false},
                    {from:this, to:this.game.discard, fstart:this.top_index()+1, n:1, internal:true},
                    {from:this, to:this.game.discard, fstart:this.top_index()+0, n:1, internal:true}];
        }
    };

    discard_pile = class extends pile {
        accept_stacks = false;
        accept(card) { return card.rank==king && 2; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return false; }
    };

    waste_pile = class extends this.constructor.discardable_pile {
        accept_stacks = false;
        accept(card, from_pile) { return from_pile.is_stock || this.accept_adds_to_13(card) && 1; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return index == this.top_index(); }
        split_move(start, n, from) {
                    if (this.pile.length >= 1 &&
                        this.pile[this.pile.length-1].rank + from.pile[start].rank == 13)
                        return this.split_to_discard(start, n, from);
                    else
                        return [{from:from, to:this,              fstart:start,              n:1}];
        }
    };

    tableau_pile = class extends this.constructor.discardable_pile {
        constructor(div,game) {
            super(div,game,false);
        }
        uncovered() { return (!this.covered_by[0] || !this.covered_by[0].pile.length) &&
                             (!this.covered_by[1] || !this.covered_by[1].pile.length); }
        accept(card) { return this.uncovered() && this.accept_adds_to_13(card) ? 2 : 0; }
        can_drag(index) { return this.uncovered() && index == this.top_index(); }
        xoffset = 0;
        yoffset = 0;
        maxstack = 1;
        split_move(start, n, from) { return this.split_to_discard(start, n , from); }
    };

    stock_pile = class extends this.constructor.discardable_pile {
        is_stock = true;
        accept_stacks = false;
        accept(card) { return this.accept_adds_to_13(card) && 1; }
        can_drag(index) { return index == this.top_index(); }
        split_move(start, n, from) { return this.split_to_discard(start, n, from); }
        splice = pile.prototype.splice_and_turn_over;
        xoffset = 1/90;
        yoffset = 1/131;
        maxstack = 52-35-1;
    };

    deal(deck) {
            this.stock.pile = deck;
            for (var c in this.stock.pile)
                this.stock.pile[c].face = down;
            for (var c in this.tableau) {
                this.tableau[c].push(this.stock.pop());
                this.tableau[c].top().face = up;
            }
    }

    fix_replay_move(moves) {
            // Old Pyramid games are tricky to fix because we have to distinguish between 2 cards being discarded and a single king accidentally combined with the next move.
            return moves.replace(/^(.)2(.)2/, function(m, c1, c2) { return this.piles[base64.from(c1)].pile[0].rank != king ? c1+c2 : c1+"2"+c2+"2" }.bind(this));
    }

    is_complete() {
            for (var i in this.tableau)
                if (this.tableau[i].pile.length) {
                    for (var j in this.tableau)
                        if (this.tableau[j].pile.length &&
                            this.tableau[j].uncovered() &&
                            this.tableau[i].accept(this.tableau[j].top()))
                            return NOT_COMPLETE;
                    if (this.tableau[i].uncovered() && (this.waste.pile.length && this.tableau[i].accept(this.waste.top()) ||
                                                        this.stock.pile.length && this.tableau[i].accept(this.stock.top()) ||
                                                        this.tableau[i].top().rank == king))
                        return NOT_COMPLETE;
                }
            for (var i in this.tableau)
                if (this.tableau[i].pile.length)
                    return this.stock.pile.length == 0 && GAME_OVER;
            return WON;
    }

    score() {
            return 28 - this.count_cards_in(this.tableau);
    }

    layout = grid([{padding: {y:0}},
                   "stock", {x: +.5}, "waste", {x: +1.5, y: + 0}, "tableau00"],
                  [                            {x: +3.5, y: -.5}, "tableau10","tableau11"],
                  ["discard",                  {x: +2.0, y: -.5}, "tableau20","tableau21","tableau22"],
                  [                            {x: +2.5, y: -.5}, "tableau30","tableau31","tableau32","tableau33"],
                  [                            {x: +2.0, y: -.5}, "tableau40","tableau41","tableau42","tableau43","tableau44"],
                  [                            {x: +1.5, y: -.5}, "tableau50","tableau51","tableau52","tableau53","tableau54","tableau55"],
                  [                            {x: +1.0, y: -.5}, "tableau60","tableau61","tableau62","tableau63","tableau64","tableau65", "tableau66"]);
}

module.exports = solitaire.pyramid;
// Copyright 2005-2011 David Caldwell <david@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              king=piles.king, base64=piles.base64,
                              up=piles.up, down=piles.down;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var prnt = require('./print'), sprintf=prnt.sprintf;
var lib = require('./lib'), map=lib.map;

solitaire.pyramid = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = this.options.decks;
        this.stock = new this.stock_pile("stock", this);
        this.waste = new this.waste_pile("waste", this);
        this.discard = new this.discard_pile("discard", this);
        this.tableau = [];
        var thash = {};
        for (var r=7-1; r>=0; r--)
            for (var i=0; i<=r; i++) {
                var p = new this.tableau_pile("tableau"+r+i, this);
                p.zoffset = r;
                thash["" + r + i] = p;
                p.covered_by = [ thash[sprintf("%d%d",(r+1),i)], thash[sprintf("%d%d",r+1,i+1)] ];
                this.tableau.push(p);
            }
    }
    valid_options = { decks: option_def("number", 1, "Number of decks to use") };

    static discardable_pile = class extends pile { // Adds a couple utility functions that the other piles can use for pyramid rules.
        accept_adds_to_13(card) { return this.pile.length > 0 && this.top().rank + card.rank == 13; }

        split_to_discard(start, n, from) {
            return [{from:from, to:this,              fstart:start,              n:n, tanimate:false},
                    {from:this, to:this.game.discard, fstart:this.top_index()+1, n:1, internal:true},
                    {from:this, to:this.game.discard, fstart:this.top_index()+0, n:1, internal:true}];
        }
    };

    discard_pile = class extends pile {
        accept_stacks = false;
        accept(card) { return card.rank==king && 2; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return false; }
    };

    waste_pile = class extends this.constructor.discardable_pile {
        accept_stacks = false;
        accept(card, from_pile) { return from_pile.is_stock || this.accept_adds_to_13(card) && 1; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return index == this.top_index(); }
        split_move(start, n, from) {
                    if (this.pile.length >= 1 &&
                        this.pile[this.pile.length-1].rank + from.pile[start].rank == 13)
                        return this.split_to_discard(start, n, from);
                    else
                        return [{from:from, to:this,              fstart:start,              n:1}];
        }
    };

    tableau_pile = class extends this.constructor.discardable_pile {
        constructor(div,game) {
            super(div,game,false);
        }
        uncovered() { return (!this.covered_by[0] || !this.covered_by[0].pile.length) &&
                             (!this.covered_by[1] || !this.covered_by[1].pile.length); }
        accept(card) { return this.uncovered() && this.accept_adds_to_13(card) ? 2 : 0; }
        can_drag(index) { return this.uncovered() && index == this.top_index(); }
        xoffset = 0;
        yoffset = 0;
        maxstack = 1;
        split_move(start, n, from) { return this.split_to_discard(start, n , from); }
    };

    stock_pile = class extends this.constructor.discardable_pile {
        is_stock = true;
        accept_stacks = false;
        accept(card) { return this.accept_adds_to_13(card) && 1; }
        can_drag(index) { return index == this.top_index(); }
        split_move(start, n, from) { return this.split_to_discard(start, n, from); }
        splice = pile.prototype.splice_and_turn_over;
        xoffset = 1/90;
        yoffset = 1/131;
        maxstack = 52-35-1;
    };

    deal(deck) {
            this.stock.pile = deck;
            for (var c in this.stock.pile)
                this.stock.pile[c].face = down;
            for (var c in this.tableau) {
                this.tableau[c].push(this.stock.pop());
                this.tableau[c].top().face = up;
            }
    }

    fix_replay_move(moves) {
            // Old Pyramid games are tricky to fix because we have to distinguish between 2 cards being discarded and a single king accidentally combined with the next move.
            return moves.replace(/^(.)2(.)2/, function(m, c1, c2) { return this.piles[base64.from(c1)].pile[0].rank != king ? c1+c2 : c1+"2"+c2+"2" }.bind(this));
    }

    is_complete() {
            for (var i in this.tableau)
                if (this.tableau[i].pile.length) {
                    for (var j in this.tableau)
                        if (this.tableau[j].pile.length &&
                            this.tableau[j].uncovered() &&
                            this.tableau[i].accept(this.tableau[j].top()))
                            return NOT_COMPLETE;
                    if (this.tableau[i].uncovered() && (this.waste.pile.length && this.tableau[i].accept(this.waste.top()) ||
                                                        this.stock.pile.length && this.tableau[i].accept(this.stock.top()) ||
                                                        this.tableau[i].top().rank == king))
                        return NOT_COMPLETE;
                }
            for (var i in this.tableau)
                if (this.tableau[i].pile.length)
                    return this.stock.pile.length == 0 && GAME_OVER;
            return WON;
    }

    score() {
            return 28 - this.count_cards_in(this.tableau);
    }

    layout = grid([{padding: {y:0}},
                   "stock", {x: +.5}, "waste", {x: +1.5, y: + 0}, "tableau00"],
                  [                            {x: +3.5, y: -.5}, "tableau10","tableau11"],
                  ["discard",                  {x: +2.0, y: -.5}, "tableau20","tableau21","tableau22"],
                  [                            {x: +2.5, y: -.5}, "tableau30","tableau31","tableau32","tableau33"],
                  [                            {x: +2.0, y: -.5}, "tableau40","tableau41","tableau42","tableau43","tableau44"],
                  [                            {x: +1.5, y: -.5}, "tableau50","tableau51","tableau52","tableau53","tableau54","tableau55"],
                  [                            {x: +1.0, y: -.5}, "tableau60","tableau61","tableau62","tableau63","tableau64","tableau65", "tableau66"]);
}

module.exports = solitaire.pyramid;
